import { useQueries } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { Associate } from '../../../types/associates';
import { AcademiaResponse } from '../../../types/common';
import { returnQueryConfig } from '../../../utils/commonFunctions';
import ReferredAssociateCard from '../Cards/ReferredAssociateCard';
import SideParentModal from './SideParentModal';

const AppointmentReferralDetailsModal = ({
  referrals,
  handleModalClose,
}: {
  referrals: Array<{ service: number; associate: number }>;
  handleModalClose: () => void;
}) => {
  // integration of react hooks here
  const [referredAssociateList, setReferredAssociateList] = useState<
    Array<Associate>
  >([]);

  // integration of tanstack query hooks here
  const referredAssociatesHandler = useQueries({
    queries: referrals.map((referral) => ({
      queryKey: [
        'referred-associates-by-id',
        referral.service,
        referral.associate,
      ],
      queryFn: async (): Promise<AcademiaResponse<Associate>> => {
        const response = await getPrivateAxiosInstance('user').get(
          `/referred/associate/${referral.service}/${referral.associate}/`
        );

        return response.data;
      },

      ...returnQueryConfig(true),
    })),
  });

  // setting referred associates into local state here
  useEffect(() => {
    setReferredAssociateList([]);

    referredAssociatesHandler.forEach((handler) => {
      if (handler.data?.is_success) {
        setReferredAssociateList((state) => [...state, handler.data.data]);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referredAssociatesHandler.every((handler) => handler.isSuccess)]);

  console.log(referredAssociateList, referredAssociatesHandler);

  // rendering appointment referral details modal
  return (
    <SideParentModal
      headerText='Referred Associates'
      onClick={handleModalClose}
    >
      <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
        {referredAssociateList.map((associate) => (
          <ReferredAssociateCard key={associate.id} associate={associate} />
        ))}
      </div>
    </SideParentModal>
  );
};

export default AppointmentReferralDetailsModal;
